"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_SCOPES = exports.REGION_URLS = void 0;
var types_1 = require("../types");
/**
 * Commercetools regions and cloud providers - https://docs.commercetools.com/api/general-concepts#hosts
 */
exports.REGION_URLS = (_a = {},
    _a[types_1.Region.EUROPE_GCP] = {
        auth: 'https://auth.europe-west1.gcp.commercetools.com',
        api: 'https://api.europe-west1.gcp.commercetools.com'
    },
    _a[types_1.Region.EUROPE_AWS] = {
        auth: 'https://auth.eu-central-1.aws.commercetools.com',
        api: 'https://api.eu-central-1.aws.commercetools.com'
    },
    _a[types_1.Region.NORTH_AMERICA_GCP] = {
        auth: 'https://auth.us-central1.gcp.commercetools.com',
        api: 'https://api.us-central1.gcp.commercetools.com'
    },
    _a[types_1.Region.NORTH_AMERICA_AWS] = {
        auth: 'https://auth.us-east-2.aws.commercetools.com',
        api: 'https://api.us-east-2.aws.commercetools.com'
    },
    _a[types_1.Region.AUSTRALIA_GCP] = {
        auth: 'https://auth.australia-southeast1.gcp.commercetools.com',
        api: 'https://api.australia-southeast1.gcp.commercetools.com'
    },
    _a);
exports.INVALID_SCOPES = ['anonymous_id', 'customer_id'];
//# sourceMappingURL=constants.js.map